import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/edit.module.css";
import axios from "axios";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { useLocation, useParams } from "react-router";
import Alert from "../../../Components/Alert/alert";
import { HiOutlineNewspaper, HiOutlinePaperClip, HiXCircle } from "react-icons/hi2";
import { HiPlusCircle } from "react-icons/hi";
import { Url, getUser } from "../../../Constants/globals";
import MultiSelect from "../../../Components/MultiSelect/multiselect";
import TextareaAutosize from "react-autosize-textarea";
import Loading from "../../../Components/Loading/loading";
import stylesModal from "../../../Components/DeleteModal/deletemodal.module.css";
import GoBack from "../../../Components/GoBack/goback";

async function getCompanies(){
  try {
    const res = await axios
    .get(`${Url}/companies?per_page=300`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getCompanies();
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getNewsDetails(id){
  try {
    const res = await axios
    .get(Url + "/news/"+id, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getNewsDetails(id);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function addNews(title, description, companies, type, autor, data, departamento, link, saberMais){
  if (title === "" || companies.length === 0 || (departamento === "" && type === "noticia")){
    return ["", <Alert type={"error"}>Os campos título{type === "noticia" ? ", universo " : " "}e empresas são obrigatórios</Alert>];
  }

  var finalCompanies = [];
  for (const company of companies) {
    finalCompanies.push(company.id);
  }

  var body = [];
  if (type === "noticia"){
    body = {
      title: title,
      description: description,
      companies: finalCompanies,
      creator_name: autor,
      department: departamento,
      know_more: saberMais,
      is_news: true,
    }
  }
  else {
    body = {
      title: title,
      companies: finalCompanies,
      show_date: `${data}-01`,
      uri: link,
      is_news: false
    };
  }
  try {
    const response = await axios
    .post(`${Url}/news`,
    body, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return [response.data, <Alert type={"success"}>{type === "noticia" ? "Comunicação" : "Newsletter"} adicionada com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await addNews(title, description, companies, type, autor, data, departamento, link, saberMais);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar");
      return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar"}</Alert>];
    }
  };
}

async function saveNews(id, title, description, companies, type, autor, data, departamento, old, link, saberMais){
  var finalCompanies = [];
  for (const company of companies) {
    finalCompanies.push(company.id);
  }

  var body = {};

  if (type === "noticia"){
    let finalIds = [];
    for (const fi of old){
      finalIds.push(fi.id);
    }
    body = {
      title: title,
      description: description,
      companies: finalCompanies,
      creator_name: autor,
      department: departamento,
      images: finalIds,
      know_more: saberMais,
      is_news: true
    }
  }
  else {
    body = {
      title: title,
      companies: finalCompanies,
      show_date: `${data}-01`,
      uri: link,
      is_news: false
    };
  }
  try {
    await axios
    .put(`${Url}/news/${id}`,
      body, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return <Alert type={"success"}>{type === "noticia" ? "Comunicação" : "Newsletter"} editada com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await saveNews(id, title, description, companies, type, autor, data, departamento, old, link, saberMais);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar"}</Alert>;
    }
  };
}

function PreviewModal({closeModal, title, message, oldImages, newImages, direcao, universo}) {

  const [isPoppedOut, setIsPoppedOut] = useState(false);
  
  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
        <div className={stylesModal.center}>
          <div className={stylesModal.column} style={{justifyContent: "space-between", alignItems: "start", width: "420px", overflowY: "scroll", scrollbarWidth: "none", height: "80vh", overflowX: "hidden"}}>
            <div>
              <div style={{marginBottom: "1rem", width: "400px"}}>
                <p className={stylesModal.newsPreviewInfoText}>
                  {direcao} <label className={stylesModal.newsPreviewInfoLabel}>• Agora</label>
                </p>
                <label className={stylesModal.newsPreviewInfoLabel}>{universo}</label>
              </div>
              <h3 style={{marginBottom: "5px", width: "400px"}} className={stylesModal.titleEvent}>{title}</h3>
              {
                oldImages.length > 0 || newImages.length > 0 ?
                  <div className={stylesModal.imagesNews} style={{overflowX: oldImages.length + newImages.length < 2 ? "hidden" : ""}}>
                    {
                      oldImages.length > 0 ?
                        oldImages.map((im, index) =>
                          <div key={index} className={styles.imagePreview}>
                            <img src={`${Url}/image/${im.uri}`} width={400} height={200} className={stylesModal.imageEvent} alt="" />
                          </div>
                        )
                      :""
                    }
                    {
                      newImages.length > 0 ?
                        newImages.map((im, index) =>
                          <div key={index} className={styles.imagePreview}>
                            <img src={im.preview} width={400} height={200} className={stylesModal.imageEvent} alt="" />
                          </div>
                        )
                      :""
                    }
                  </div>
                : ""
              }
              <p style={{marginTop: "20px", fontSize: "11pt", width: "400px"}} dangerouslySetInnerHTML={{ __html: message}}/>
            </div>
            <div className={stylesModal.buttons} style={{width: "100%"}}>
              <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
            </div>
          </div>
        </div>
    </div>
  );
}

function EditarComunicacoesInternas({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const [loadingData, setLoadingData] = useState(true);
  const [alert, setAlert] = useState("");
  const [loading, setLoading] = useState("");
  const newsBodyRef = useRef();
  const [preview, setPreview] = useState("");

  const [newsType, setNewsType] = useState("");

  const [title, setTitle] = useState("");
  const [autor, setAutor] = useState("");
  const [departamento, setDepartamento] = useState("");
  const [pdf, setPdf] = useState("");
  const [pdfName, setPdfName] = useState("");
  const [link, setLink] = useState("");
  const [linkSaberMais, setLinkSaberMais] = useState("");

  const [newsImages, setNewsImages] = useState([]);
  const [oldNewsImages, setOldNewsImages] = useState([]);

  const [monthYear, setMonthYear] = useState(`${new Date().getFullYear()}-${new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1}`)

  const [companies, setCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const [newsBody, setNewsBody] = useState('');

  const [selectedFileType, setSelectedFileType] = useState("");

  const fileInputRef = useRef(null);

  const handleImageUpload = () => fileInputRef.current.click();

  async function assignData() {
    const thisCompaniesData = await getCompanies();
    setCompanies(thisCompaniesData.companies);
    if (id){
      const thisNewsDetailsData = await getNewsDetails(id);
      if (thisNewsDetailsData.is_news){
        setNewsType("noticia");
        if (thisNewsDetailsData.images.length > 0) setOldNewsImages(thisNewsDetailsData.images);
        setLinkSaberMais(thisNewsDetailsData.know_more ?? "");
      }
      else {
        setNewsType("newsletter");
        if (thisNewsDetailsData.uri) {
          setLink(thisNewsDetailsData.uri);
          setSelectedFileType("link");
        }
        else if (thisNewsDetailsData.pdf) setSelectedFileType("file");
        if (thisNewsDetailsData.pdf) setPdfName(thisNewsDetailsData.pdf);
      }
      setTitle(thisNewsDetailsData.title);
      setDepartamento(thisNewsDetailsData.department ?? "");
      setAutor(thisNewsDetailsData.creator_name);
      if (thisNewsDetailsData.show_date) setMonthYear(thisNewsDetailsData.show_date);
      setNewsBody(thisNewsDetailsData.description);
      setSelectedCompanies(thisNewsDetailsData.companies ?? []);
    }
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);

  async function changeFile(){
    const formData = new FormData();
    formData.append('file', pdf);
    try {
      await axios.post(`${Url}/news/${id}/image`, formData, {
        headers: {
          Authorization: "Bearer " + getUser().token,
          'Content-Type': 'multipart/form-data'
        }
      })
      return;
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await changeFile();
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o documento");
        return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o documento"}</Alert>;
      }
    }
  }

  async function changeFiles(){
    const formData = new FormData();
    for (const f of newsImages){
      formData.append('file', f);
    }
    try {
      const res = await axios.post(`${Url}/news/${id}/image`, formData, {
        headers: {
          Authorization: "Bearer " + getUser().token,
          'Content-Type': 'multipart/form-data'
        }
      })
      return [false, res.data];
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await changeFiles();
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar as imagens");
        return [true, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar as imagens"}</Alert>];
      }
    }
  }

  async function getAlertEdit() {
    await setAlert("");
    let responseFiles = "";
    if (title === "" || selectedCompanies.length === 0 || (departamento === "" && newsType === "noticia")) return setAlert(<Alert type={"error"}>Os campos título{newsType === "noticia" ? ", universo " : " "}e empresas são obrigatórios</Alert>);
    if (newsType === "newsletter" && (!pdf && !link)) return setAlert(<Alert type="error">Insira o ficheiro ou o link da newsletter</Alert>);
    await setLoading(<Loading/>);
    if (pdf) {
      const responseFile = await changeFile();
      if (responseFile){
        setLoading("");
        return setAlert(responseFile);
      }
    }
    else if (newsImages.length > 0){
      responseFiles = await changeFiles();
      if (responseFiles[0]){
        setLoading("");
        return setAlert(responseFiles[1]);
      }
    }
    const res = await saveNews(id, title, newsBody, selectedCompanies, newsType, autor, monthYear, departamento, responseFiles?.length > 0 ? [...oldNewsImages, ...responseFiles[1]] : oldNewsImages, link, linkSaberMais);
    await setNewsImages([]);
    await assignData();
    await setLoading("");
    return setAlert(res);
  }

  async function addNewsFile(newsId){
    const formData = new FormData();
    formData.append('file', pdf);
    try {
      await axios.post(`${Url}/news/${newsId}/image`, formData, {
        headers: {
          Authorization: "Bearer " + getUser().token,
          'Content-Type': 'multipart/form-data'
        }
      })
      return;
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await addNewsFile(newsId);
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o documento");
        return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar o documento"}</Alert>;
      }
    }
  }

  async function addNewsFiles(newsId){
    const formData = new FormData();
    for (const f of newsImages){
      formData.append('file', f);
    }
    try {
      await axios.post(`${Url}/news/${newsId}/image`, formData, {
        headers: {
          Authorization: "Bearer " + getUser().token,
          'Content-Type': 'multipart/form-data'
        }
      })
      return;
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await addNewsFiles(newsId);
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar as imagens");
        return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar as imagens"}</Alert>;
      }
    }
  }

  async function getAlertAdd() {
    await setAlert("");
    if (newsType === "newsletter" && (!pdf && !link)) return setAlert(<Alert type="error">Insira o ficheiro ou o link da newsletter</Alert>);
    await setLoading(<Loading/>);
    const res = await addNews(title, newsBody, selectedCompanies, newsType, autor, monthYear, departamento, link, linkSaberMais);
    if (pdf && res[0]) {
      const resFile = await addNewsFile(res[0]);
      if (resFile){
        setLoading("");
        return setAlert(resFile);
      }
    }
    else if (newsImages.length > 0 && res[0]){
      const resFiles = await addNewsFiles(res[0]);
      if (resFiles){
        setLoading("");
        return setAlert(resFiles);
      }
    }
    setLoading("");
    return setAlert(res[1]);
  }

  async function checkIfImageExists(name) {
    await setAlert("");
    if (name === link) return window.open(name, "_blank");
    try {
      const res = await axios.get(`${Url}/image/${name}`, {
        headers: {
          Authorization: "Bearer "+getUser().token,
        },
        responseType: "arraybuffer"
      });
      const blob = new Blob([res.data]);
      const pdfUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await checkIfImageExists(name);
        } else {
          window.location.reload();
        }
      }
      else return setAlert(<Alert type="error">O ficheiro não foi encontrado</Alert>);
    }
  }

  function handleNewsImages(event){
    const files = event.target.files;
    const promises = [];
    for(const f of files){
      if (f.type.startsWith('image/')){
        promises.push(readFile(f));
      }
      else {
        return setAlert(<Alert type="error">Apenas imagens são permitidas</Alert>);
      }
    }
    Promise.all(promises).then(images => {
      setNewsImages(prevImages => [...prevImages, ...images]);
    });
  }

  function readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        file.preview = reader.result;
        resolve(file);
      };
      reader.onerror = error => reject(error);
    });
  }

  function popImage(array, setArray, image){
    let finalArray = [...array];
    if (array.includes(image)) {
      finalArray = array.filter((img) => img !== image);
    }
    setArray(finalArray);
  }

  function handleBoldText(type) {
    const input = newsBodyRef?.current;
    if (input) {
      const start = input.selectionStart;
      const end = input.selectionEnd;
      var selectedText = input.value.substring(start, end);
      if (selectedText === ""){

        let modifiedText = "";

        if (input.value.substring(start - 3, start + 4) === `<${type}></${type}>`){
          modifiedText = false;
        }
        else {
          modifiedText = `<${type}></${type}>`;
        }

        const newText = modifiedText ? input.value.substring(0, start) + modifiedText + input.value.substring(end) : input.value.substring(0, start - 3) + input.value.substring(start + 4, input.value.length);
        setNewsBody(newText);

        let newStart = modifiedText ? start + 3 : start - 3;

        setTimeout(() => {
          input.focus();
          input.setSelectionRange(newStart, newStart);
        }, 0);
      }
      else {
        let modifiedText = "";

        if (selectedText.substring(0, 3) === `<${type}>` && selectedText.substring(selectedText.length - 4, selectedText.length) === `</${type}>`){
          modifiedText = `${selectedText.slice(3, selectedText.length - 4)}`;
        }
        else {
          modifiedText = `<${type}>${selectedText}</${type}>`;
        }
        const newText = input.value.substring(0, start) + modifiedText + input.value.substring(end);
        setNewsBody(newText);

        let newStart = start;
        let newEnd = end;
        if (selectedText.substring(0, 3) === `<${type}>` && selectedText.substring(selectedText.length - 4, selectedText.length) === `</${type}>`) {
          newEnd = start + (end - start - 7);
        } else {
          newEnd = start + modifiedText.length;
        }
        setTimeout(() => {
          input.focus();
          input.setSelectionRange(newStart, newEnd);
        }, 0);
      }

    }
  }

  function handleXFileType(){
    setPdf("");
    setPdfName("");
    setLink("");
    setSelectedFileType("");
  }
    
  useEffect(() => {
    if (id) assignData();
    else setLoadingData(false);
  }, []);

  return (
    <div className="body">
      {loading}
      {alert}
      {preview}
      <NavBar current={"comunicacoes-internas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ?
        ""
        :
        newsType === "noticia"
        ?
        <div className={styles.content}>
          <GoBack backRoute={`/comunicacoes-internas`} backState={state?.page ? {page: state.page} : {}} />
          {
            id ?
            <h1 className={styles.backgroundName}>Editar comunicação</h1>
            :
            <h1 className={styles.backgroundName}>Adicionar comunicação</h1>
          }
          <div className={styles.formBlock}>
            <MultiSelect
              label={"Empresas:"}
              items={companies}
              placeholder={"Escolher empresas"}
              value={selectedCompanies}
              onValueChange={setSelectedCompanies}
            />
            <div className={styles.formBlockSection}>
              <p>Direção:</p>
              <input
                defaultValue={autor}
                onChange={(e) => setAutor(e.target.value)}
              />
            </div>
            <div className={styles.formBlockSection}>
              <p>Universo:</p>
              <input
                defaultValue={departamento}
                onChange={(e) => setDepartamento(e.target.value)}
              />
            </div>
            <div className={styles.formBlockSection}>
              <p>Link (saber mais):</p>
              <input
                defaultValue={linkSaberMais}
                onChange={(e) => setLinkSaberMais(e.target.value)}
              />
            </div>
            <div className={styles.formBlockSection} style={{gridColumnStart: 1, gridColumnEnd: 3}}>
              <p>Título:</p>
              <input
                defaultValue={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className={styles.formBlockSection} style={{gridColumnStart: 1, gridColumnEnd: 3}}>
              <p>Corpo da comunicação:</p>
              <div style={{width: "100%", paddingRight: "1rem"}}>
                {
                  newsBody?.length > 0 ?
                  <div className={styles.textButtons}>
                    <button className={styles.textButton} style={{fontWeight: "bold"}} onClick={() => handleBoldText("b")}>B</button>
                    <button className={styles.textButton} style={{fontStyle: "italic"}} onClick={() => handleBoldText("i")}>I</button>
                    <button className={styles.textButton} style={{textDecoration: "underline"}} onClick={() => handleBoldText("u")}>U</button>
                  </div>
                  : ""
                }
                <TextareaAutosize
                  ref={newsBodyRef}
                  style={{resize: "none"}}
                  onChange={(e) => setNewsBody(e.target.value.replace(/\\/g, ''))}
                  value={newsBody}
                  onKeyDown={(e) => {
                    if (e.key === "\\") return;
                    if (e.key === "Tab") {
                      e.preventDefault();
                      var val = e.target.value,
                      start = e.target.selectionStart,
                      end = e.target.selectionEnd;

                      // set textarea value to: text before caret + tab + text after caret
                      e.target.value = val.substring(0, start) + "\t" + val.substring(end);

                      e.target.selectionStart = e.target.selectionEnd = start + 1;

                      setNewsBody(e.target.value);
                      // prevent the focus lose
                      return false;
                    }
                  }}
                />
              </div>
            </div>
            <div className={styles.formBlockSection} style={{gridColumnStart: 1, gridColumnEnd: 3, padding: "0.4rem 1rem", margin: 0, flexWrap: "wrap"}}>
              <div className={styles.actions}>
                <HiPlusCircle onClick={() => handleImageUpload()} className={styles.icon} size={22}/>
              </div>
              <p>Imagens:</p>
              <input
                ref={fileInputRef}
                style={{display: "none"}}
                type="file"
                multiple
                accept=".jpg, .jpeg, .png"
                onChange={(e) => {
                  handleNewsImages(e);
                }}
              />
              {
                oldNewsImages.length > 0 ?
                  oldNewsImages.map((im, index) =>
                    <div key={index} className={styles.imagePreview}>
                      <HiXCircle className={styles.imageRemoveIcon} color="red" onClick={() => popImage(oldNewsImages, setOldNewsImages, im)}/>
                      <img src={`${Url}/image/${im.uri}`} alt="img" style={{ maxWidth: '100px', maxHeight: '100px', borderRadius: "4px"}} />
                    </div>
                  )
                :""
              }
              {
                newsImages.length > 0 ?
                  newsImages.map((im, index) =>
                    <div key={index} className={styles.imagePreview}>
                      <HiXCircle className={styles.imageRemoveIcon} color="red" onClick={() => popImage(newsImages, setNewsImages, im)}/>
                      <img src={im.preview} alt={`Preview ${im.name}`} style={{ maxWidth: '100px', maxHeight: '100px', borderRadius: "4px"}} />
                    </div>
                  )
                :""
              }
            </div>
          </div>
          <div style={{display: "flex", gap: "1rem"}}>
            <button disabled={title.trim() === ""} style={title.trim() === "" ? {opacity: "0.8", cursor: "not-allowed"} : {}} className={styles.btn} onClick={() => setPreview(<PreviewModal closeModal={setPreview} message={newsBody.replaceAll("\n", "<br>")} title={title} oldImages={oldNewsImages} newImages={newsImages} direcao={autor} universo={departamento} />)}>Pré-visualizar</button>
            {
              id ?
              <button className={styles.btn} type="" onClick={() => getAlertEdit()}>Guardar alterações</button>
              :
              <button className={styles.btn} type="" onClick={() => getAlertAdd()}>Adicionar comunicação</button>
            }
          </div>
        </div>
        : 
        newsType === "newsletter" ?
        <div className={styles.content}>
          <GoBack backRoute={`/comunicacoes-internas`} backState={state?.page ? {page: state.page} : {}} />
          {
            id ?
            <h1 className={styles.backgroundName}>Editar newsletter</h1>
            :
            <h1 className={styles.backgroundName}>Adicionar newsletter</h1>
          }
          <div className={styles.formBlock}>
            <div className={styles.formBlockSection}>
              <p>Título:</p>
              <input
                defaultValue={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <MultiSelect
              label={"Empresas:"}
              items={companies}
              placeholder={"Escolher empresas"}
              value={selectedCompanies}
              onValueChange={setSelectedCompanies}
            />
            {
              selectedFileType === "file" ?
                <div className={styles.formBlockSection}>
                  <p style={{display: "flex", gap: "8px"}}><HiXCircle color="var(--buttonBackground)" style={{cursor: "pointer"}} size={18} onClick={() => handleXFileType()} /> Ficheiro:</p>
                  {
                    pdfName ? 
                    <div style={{display: "flex", width: "100%", gap: "10px", justifyContent: "space-between"}}>
                      <p style={{cursor: "pointer", fontSize: "12pt", color: "var(--text)", wordBreak: "break-all"}} onClick={() => checkIfImageExists(pdfName)}>{pdfName}</p>
                      <button className={styles.servicesButton} style={{margin: "5px", height: "fit-content", alignSelf: "center"}} onClick={() => {setPdf(""); setPdfName("");}}>Alterar</button>
                    </div>
                    :
                    <input
                      type="file"
                      onChange={(e) => {
                        setPdf(e.target.files[0]);
                        setPdfName(e.target.files[0].name)
                      }}
                    />
                  }
                </div>
              :
              selectedFileType === "link" ?
                <div className={styles.formBlockSection}>
                  <p style={{display: "flex", gap: "8px"}}><HiXCircle color="var(--buttonBackground)" style={{cursor: "pointer"}} size={18} onClick={() => handleXFileType()} />Link:</p>
                  <input
                    placeholder="URL da newsletter"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                  />
                </div>
              :
                <div className={styles.chooseFileType}>
                  <p>Tipo de newsletter:</p>
                  <div className={styles.btnsFileType}>
                    <button className={styles.btnFileType} onClick={() => setSelectedFileType("file")}>Ficheiro</button>
                    <button className={styles.btnFileType} onClick={() => setSelectedFileType("link")}>Link</button>
                  </div>
                </div>
            }
            <div className={styles.formBlockSection}>
              <p>Data:</p>
              <input
                type="month"
                value={monthYear}
                onChange={(e) => setMonthYear(e.target.value)}
              />
            </div>
          </div>
          {
            id ?
            <button className={styles.btn} onClick={() => getAlertEdit()}>Guardar alterações</button>
            :
            <button className={styles.btn} onClick={() => getAlertAdd()}>Adicionar newsletter</button>
          }
        </div>
        : 
        <div className={styles.content}>
          <h1 className={styles.backgroundName}>Adicionar</h1>
          <div className={styles.newsTypes}>
            <button onClick={() => setNewsType("noticia")}><HiOutlineNewspaper size={100}/>Comunicação</button>
            <button onClick={() => setNewsType("newsletter")}><HiOutlinePaperClip size={100}/>Newsletter</button>
          </div>
        </div>
      }
    </div>
  );
}

export default EditarComunicacoesInternas;
